export default __webpack_public_path__ + "static/media/skipped2.7f017434.png";